import { render, staticRenderFns } from "./product_weidian.vue?vue&type=template&id=11a48dfd&scoped=true&"
import script from "./product_weidian.vue?vue&type=script&lang=js&"
export * from "./product_weidian.vue?vue&type=script&lang=js&"
import style0 from "./product_weidian.vue?vue&type=style&index=0&id=11a48dfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a48dfd",
  null
  
)

export default component.exports